<template>
  <!-- Replaced by Instagram-style Bottom Navigation Bar -->
  <div class="d-none"></div>
</template>

<script>
export default {
  name: "PwaActionBar",
  props: {
    showSubscribers: { type: Boolean, default: false },
    showMessage: { type: Boolean, default: true },
    showRequests: { type: Boolean, default: true },
    showContext: { type: Boolean, default: false },
    contextIcon: { type: String, default: 'fa-plus' },
    contextLabel: { type: String, default: 'Action' },
    url: { type: String, default: '' }
  }
}
</script>

